import { BoldIcon } from '../icons/BoldIcon';
import { ItalicIcon } from '../icons/ItalicIcon';
import { InlineToolbar, ToolbarItem } from './TextEditor.styles';
import { IlineToolbarPropType } from './TextEditor.types';

export function InlineStyleToolBar(props: IlineToolbarPropType): JSX.Element {
  const { currentState, onChange } = props;

  return (
    <InlineToolbar>
      <ToolbarItem
        onClick={() => onChange('BOLD')}
        $active={currentState?.bold}
        title="Bold"
      >
        <BoldIcon />
      </ToolbarItem>
      <ToolbarItem
        onClick={() => onChange('ITALIC')}
        title="Italic"
        $active={currentState?.italic}
      >
        <ItalicIcon />
      </ToolbarItem>
    </InlineToolbar>
  );
}
